import React, { useEffect, useState } from 'react';
import { Switch, Route, useLocation, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';

import './App.css';
import Header from './components/HeaderComponent/Header';
import FooterComponent from './components/FooterComponent/FooterComponent';
import PaymentBankDetails from './components/PaymentBankDetails/PaymentBankDetails';
import VerifyDetailsConfirm from './components/VerifyDetailsConfirm/VerifyDetailsConfirm';
import Registration1 from './components/Registration/Registration1';
import Registration2 from './components/Registration/Registration2';
import GuestRegistration from './components/GuestRegistration/GuestRegistration';
import MobileConfirmation from './components/UserTable/MobileConfirmation';
import ForgotPassword from './components/ForgotPassword/ForgotPassword';
import Acknowledgement from './components/Acknowledgement/Acknowledgement';
import ContactUs from './components/ContactUs/ContactUs';
import Faq from './components/faq/Faq';
import BsmTnc from './components/BsmTnc/BsmTnc';
import PrivacyNotice from './components/PrivacyNotice/PrivacyNotice';
import CookieNotice from './components/CookieNotice/CookieNotice';
import PaymentsList from './components/UserTable/PaymentList/PaymentsListTable';
import AccountHistoryTable from './components/UserTable/PaymentList/AccountHistoryTable';
import PaymentHistoryTable from './components/UserTable/PaymentList/PaymentHistoryTable';
import HelpVideo from './components/HelpVideo/HelpVideo';
import { GuestLogin } from './components/LoginRegister/GuestLogin';
import { RegisteredLogin } from './components/LoginRegister/RegisteredLogin';
import ScrollToTopComponent from './components/ScrollToTopComponent/ScrollToTopComponent';
import { ThemeProvider } from 'styled-components';
import theme from '@blueprint/theme';
import backgroundImage from './hsbcBackground.jpg';
import ScrollToTopOnNav from './components/ScrollToTopOnNav/ScrollToTopOnNav';
import ServerErrorLabel from './components/ServerErrorLabel/ServerErrorLabel';
import SessionWarningModal from './components/SessionWarningModal/SessionWarningModal';
import { resetSessionRefreshTimer, sessionTimeout, fetchConfig, fetchCustomerLogo } from './actions/index';
import CONSTANTS from './constants/constants';

const useStyles = makeStyles({
    root: {
        fontFamily: 'UniversNextforHSBC',
    },
});

function App() {
    const history = useHistory();
    const dispatch = useDispatch();
    const classes = useStyles();
    const location = useLocation();
    const { t } = useTranslation();
    const globalState = useSelector((state) => state);
    const ENTER_BANK_DETAILS = process.env.REACT_APP_BANK_DETAILS;
    const VERIFY_DETAILS_CONFIRM = process.env.REACT_APP_VERIFY_DETAILS_CONFIRM;
    const REGISTRATION_STEP_1 = process.env.REACT_APP_REGISTRATION_STEP_1;
    const REGISTRATION_STEP_2 = process.env.REACT_APP_REGISTRATION_STEP_2;
    const GUEST_REGISTRATION = process.env.REACT_APP_GUEST_REGISTRATION;
    const MOBILE_CONFIRMATION = process.env.REACT_APP_MOBILE_CONFIRMATION;
    const FORGOT_PASSWORD = process.env.REACT_APP_FORGOT_PASSWORD;
    const ACKNOWLEDGEMENT = process.env.REACT_APP_ACKNOWLEDGEMENT;
    const CONTACT_US = process.env.REACT_APP_CONTACT_US;
    const FAQ = process.env.REACT_APP_FAQ;
    const BSM_TNC = process.env.REACT_APP_BSM_TNC;
    const PRIVACY_NOTICE = process.env.REACT_APP_PRIVACY_NOTICE;
    const COOKIE_NOTICE = process.env.REACT_APP_COOKIE_NOTICE;
    const HELP_VIDEO = process.env.REACT_APP_HELP_VIDEO;
    const PAYMENT_LIST = process.env.REACT_APP_PAYMENT_LIST;
    const ACCOUNT_HISTORY = process.env.REACT_APP_ACCOUNT_HISTORY;
    const PAYMENT_HISTORY = process.env.REACT_APP_PAYMENT_HISTORY;
    const LOGIN_TAB = process.env.REACT_APP_LOGIN_TAB;
    const LOGGEDIN_USER_SESSION_TIME = process.env.REACT_APP_LOGGEDIN_USER_SESSION_TIME;
    const [sessionWarning, setSessionWarning] = useState(false);

    const [captchaErrorPopup, setCaptchaErrorPopup] = useState(false);

    if (window.location.href.includes('?user=signup') && window.location.href.includes('/login/signin') && location.pathname !== '/') {
        let entireURL = window.location.href;
        let cid = '';
        if (entireURL.includes('?cid=')) {
            let separatedURL = entireURL.split('?cid=');
            cid = separatedURL[1];
            history.push(`/?cid=${cid}`);
            console.log(`Pushing to /?cid=${cid}`);
        } else {
            history.push('/');
            console.log(`Pushing to /, There is no cid`);
        }
    }

    useEffect(() => {
        dispatch(fetchConfig());
    }, []);

    useEffect(() => {
        if (globalState.beneDetails.captchaConfig?.appdkey) {
            console.log(`Appdkey is ${globalState.beneDetails.captchaConfig?.appdkey}`);

            const script = document.createElement('script');
            script.src = '//cdn.appdynamics.com/adrum/adrum-21.2.0.3385.js';
            script.async = true;
            document.head.appendChild(script);
            window['adrum-start-time'] = new Date().getTime();
            (function (config) {
                config.appKey = globalState.beneDetails.captchaConfig.appdkey;
                config.adrumExtUrlHttp = 'http://cdn.appdynamics.com';
                config.adrumExtUrlHttps = 'https://cdn.appdynamics.com';
                config.beaconUrlHttp = 'http://fra-col.eum-appdynamics.com';
                config.beaconUrlHttps = 'https://fra-col.eum-appdynamics.com';
                config.resTiming = { bufSize: 200, clearResTimingOnBeaconSend: true };
                config.maxUrlLength = 512;
            })(window['adrum-config'] || (window['adrum-config'] = {}));
        }
    }, [globalState.beneDetails.captchaConfig]);

    useEffect(() => {
        if (!globalState.beneDetails.calledLogoApi && globalState.beneDetails.details.isLogged) {
            dispatch(fetchCustomerLogo());
        }
    }, [globalState.beneDetails.details.isLogged]);

    useEffect(() => {
        var timer;

        if (globalState.beneDetails.sessionRefreshTimer === 0) {
            clearTimeout(timer);
        }

        let externalPages = ['/', LOGIN_TAB, FORGOT_PASSWORD, FAQ, BSM_TNC, PRIVACY_NOTICE, COOKIE_NOTICE, HELP_VIDEO];
        if (externalPages.includes(location.pathname)) {
            console.log('TIMEOUT | Clearing timer');
            resetSessionRefreshTimer();
        } else {
            console.log(`TIMEOUT | Starting timer for ${LOGGEDIN_USER_SESSION_TIME} from 0s`);
            timer = setTimeout(() => {
                console.log('TIMEOUT | Timer is up, User will be pushed out');
                // dispatch(sessionTimeout());
                // SHow popup
                setSessionWarning(true);
            }, (CONSTANTS.SESSION_PERIOD - CONSTANTS.WARNING_COUNTDOWN / 60) * 60 * 1000);
        }

        // Clear timeout before App unmounts
        return () => {
            clearTimeout(timer);
        };
    }, [globalState.beneDetails.sessionRefreshTimer, location.pathname]);

    useEffect(() => {
        switch (location.pathname) {
            case '/':
                document.title = t('loginPage.hsbc_bm');
                break;
            case '/login':
                document.title = t('loginPage.hsbc_bm');
                break;
            case GUEST_REGISTRATION:
                document.title = t('guestUserPage.title');
                break;
            case PAYMENT_LIST:
                document.title = t('userTable.section_title');
                break;
            case ACCOUNT_HISTORY:
                document.title = t('accountHistory.accountHistory');
                break;
            case PAYMENT_HISTORY:
                document.title = t('paymentHistory.paymentHistory');
                break;
            case ENTER_BANK_DETAILS:
                document.title = t('paymentBankDetails.payment_bank_details');
                break;
            case VERIFY_DETAILS_CONFIRM:
                document.title = t('verifyDetailsConfirm.section_title');
                break;
            case ACKNOWLEDGEMENT:
                document.title = t('acknowledgementPage.section_title');
                break;
            case REGISTRATION_STEP_1:
                document.title = t('registrationPageOne.section_title');
                break;
            case REGISTRATION_STEP_2:
                document.title = t('registrationPageTwo.section_title');
                break;
            case HELP_VIDEO:
                document.title = t('helpVideo.sectionTitle');
                break;
            case FAQ:
                document.title = t('faq.frequentlyAskedQuestions');
                break;
            case BSM_TNC:
                document.title = t('bsmTnc.bsmWebsiteTnc');
                break;
            case PRIVACY_NOTICE:
                document.title = t('privacyNotice.privacyNoticeBsm');
                break;
            case COOKIE_NOTICE:
                document.title = t('cookiePolicy.cookieNotice');
                break;
            case CONTACT_US:
                document.title = t('contactUs.contactUs');
                break;
            case FORGOT_PASSWORD:
                document.title = t('forgotPassword.section_title');
                break;
            case MOBILE_CONFIRMATION:
                document.title = t('mobileConfirmationPage.section_title');
                break;
            default:
                document.title = 'HSBC Beneficiary Managememt';
        }
    }, [location.pathname]);

    var showBackgroundImage;
    if (location.pathname === `/` || location.pathname === `/login` || location.pathname === '/login/signin') {
        showBackgroundImage = true;
    } else {
        showBackgroundImage = false;
    }
    return (
        <div
            className='App'
            style={{ backgroundImage: showBackgroundImage ? `url(${backgroundImage})` : null, backgroundSize: 'cover', backgroundPositionY: '50%' }}
        >
            <div id='app-helper' className={classes.root}>
                <ThemeProvider theme={{ ...theme }}>
                    <ServerErrorLabel />
                    <ScrollToTopOnNav />
                    <Header />
                    <SessionWarningModal open={sessionWarning} setOpen={setSessionWarning} />
                    <Switch>
                        <Route path={ENTER_BANK_DETAILS} component={PaymentBankDetails} />
                        <Route path={VERIFY_DETAILS_CONFIRM} component={VerifyDetailsConfirm} />
                        <Route path={REGISTRATION_STEP_1} component={Registration1} />
                        <Route path={REGISTRATION_STEP_2} component={Registration2} />
                        <Route path={GUEST_REGISTRATION} component={GuestRegistration} />
                        <Route path={MOBILE_CONFIRMATION} component={MobileConfirmation} />
                        <Route path={FORGOT_PASSWORD} component={ForgotPassword} />
                        <Route path={ACKNOWLEDGEMENT} component={Acknowledgement} />
                        <Route path={PAYMENT_LIST} component={PaymentsList} />
                        <Route path={ACCOUNT_HISTORY} component={AccountHistoryTable} />
                        <Route path={PAYMENT_HISTORY} component={PaymentHistoryTable} />
                        <Route path={CONTACT_US} component={ContactUs} />
                        <Route path='/login' component={RegisteredLogin} />
                        <Route exact path='/' component={GuestLogin} />
                    </Switch>
                    <ScrollToTopComponent />
                    <Switch>
                        <Route path={FAQ} component={Faq} />
                        <Route path={HELP_VIDEO} component={HelpVideo} />
                        <Route path={BSM_TNC} component={BsmTnc} />
                        <Route path={PRIVACY_NOTICE} component={PrivacyNotice} />
                        <Route path={COOKIE_NOTICE} component={CookieNotice} />
                        <Route
                            path='/'
                            render={(props) => (
                                <>
                                    <FooterComponent />
                                </>
                            )}
                        />
                    </Switch>
                </ThemeProvider>
            </div>
        </div>
    );
}

export default App;
